/* @flow */
import React from 'react';

import i18n from '@remind/i18n';

class Time extends React.Component {
  static propTypes = {
    date: React.PropTypes.instanceOf(Date).isRequired,
    weekday: React.PropTypes.oneOf(['narrow', 'short', 'long']),
    era: React.PropTypes.oneOf(['narrow', 'short', 'long']),
    year: React.PropTypes.oneOf(['numeric', '2-digit']),
    month: React.PropTypes.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
    day: React.PropTypes.oneOf(['numeric', '2-digit']),
    hour: React.PropTypes.oneOf(['numeric', '2-digit']),
    minute: React.PropTypes.oneOf(['numeric', '2-digit']),
    second: React.PropTypes.oneOf(['numeric', '2-digit']),
    timeZoneName: React.PropTypes.oneOf(['short', 'long']),
    timeZone: React.PropTypes.string,
    hour12: React.PropTypes.bool,
  };

  render() {
    const { className, date, ...rest } = this.props;
    return (
      <span className={className}>
        {i18n.getDate(date, rest)}
      </span>
    );
  }
}

export default Time;



// WEBPACK FOOTER //
// ./src/components/Time.jsx